import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.css'],
  standalone: true
})
export class LoadingSpinnerComponent implements OnInit, OnDestroy {
  private liveAnnouncer = inject(LiveAnnouncer);
  private announceTimer: ReturnType<typeof setTimeout> | null = null;

  ngOnInit(): void {
    this.announceTimer = setTimeout(() => {
      this.liveAnnouncer.announce('Just a moment…', 'assertive');
    }, 300);
  }

  ngOnDestroy(): void {
    if (this.announceTimer) {
      clearTimeout(this.announceTimer);
    }
    this.liveAnnouncer.announce('Loading complete.', 'assertive');
  }
}
